import React from 'react';
import { MapPin, Phone, Clock, Building2 } from 'lucide-react';

const GoogleMap = () => {
  return (
    <section className="py-12 bg-slate-900" data-testid="google-map-section">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 flex items-center justify-center gap-2">
              <MapPin className="w-6 h-6 text-cyan-400" />
              Nossa Localização
            </h2>
            <p className="text-slate-400 text-sm">Agendar um Horário para Atendimento</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Info Card */}
            <div className="bg-slate-800/60 border border-slate-700/50 rounded-2xl p-6 space-y-5">
              <div className="flex items-start gap-3">
                <div className="bg-cyan-500/10 p-2 rounded-lg flex-shrink-0">
                  <Building2 className="w-5 h-5 text-cyan-400" />
                </div>
                <div>
                  <span className="text-xs font-semibold text-cyan-400 bg-cyan-500/10 px-2 py-0.5 rounded-full">Escritório Comercial</span>
                  <p className="text-white font-medium mt-2 text-sm leading-relaxed">
                    Rua Major Leopoldo José Leonardeli, N° 100
                  </p>
                  <p className="text-slate-400 text-sm">
                    Dom Bernardo Jose Mielle
                  </p>
                  <p className="text-slate-400 text-sm">
                    Ribeirão Preto - SP, 14057-420
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="bg-green-500/10 p-2 rounded-lg flex-shrink-0">
                  <Phone className="w-5 h-5 text-green-400" />
                </div>
                <div>
                  <p className="text-white font-medium text-sm">(16) 99137-8312</p>
                  <p className="text-slate-500 text-xs">WhatsApp e Telefone</p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="bg-yellow-500/10 p-2 rounded-lg flex-shrink-0">
                  <Clock className="w-5 h-5 text-yellow-400" />
                </div>
                <div>
                  <p className="text-white font-medium text-sm">Seg a Sex: 08h - 18h</p>
                  <p className="text-slate-400 text-sm">Sáb: 08h - 12h</p>
                </div>
              </div>

              <a
                href="https://maps.google.com/?cid=12969463864806061103"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-500 hover:to-blue-500 text-white font-bold py-3 rounded-xl text-sm transition-all w-full"
                data-testid="google-maps-route-btn"
              >
                <MapPin className="w-4 h-4" />
                Traçar Rota no Google Maps
              </a>
            </div>

            {/* Map Embed */}
            <div className="lg:col-span-2 rounded-2xl overflow-hidden border border-slate-700/50 min-h-[300px]">
              <iframe
                src="https://maps.google.com/maps?q=Rua+Major+Leopoldo+Jos%C3%A9+Leonardeli,+100+-+Dom+Bernardo+Jose+Mielle,+Ribeir%C3%A3o+Preto+-+SP,+14057-420&t=&z=16&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: '350px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização Fernando Tech - Escritório Comercial"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleMap;
